import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue, NonRequired } from 'src/lib/validation/ValidationTypes';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const SonstigeInformationEmobLis: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Sonstige Informationen' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={
					P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0239910483_ationen_Pruefung_Pruefstatus.path
				}
				hinweisPath={
					P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0047227314_nweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0249670381_en_Pruefung_Ueberarbeitet_Am.path
				}
				erledigtPath={
					P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0063542836_ormationen_Pruefung_Erledigt.path
				}
				formStruc={formStrucPruefAssistenz()}
			/>

			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default SonstigeInformationEmobLis;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0063542836_ormationen_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0138299063_umme_Und_Jahr_Der_Foerderung,
				P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0072338435_Des_Ausschreibungsverfahrens,
				{
					...P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0044053758_erderrelevante_Informationen,
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucSonstigeInformationEmobLis = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0239910483_ationen_Pruefung_Pruefstatus.path,
			P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0063542836_ormationen_Pruefung_Erledigt.path,
		)
	) {
		return concat(formStrucPruefAssistenz(), formStruc());
	} else return concat(formStruc());
};
